import { TipDetail } from '@core/models';
import { CustomTipInput } from '../interfaces/custom-tip-input.interface';

// TODO: Confirm these existing UI limits are business rules; preserve them until confirmed.
export const CUSTOM_TIP_MAX_AMOUNT = 999;
export const CUSTOM_TIP_MAX_DECIMAL_PLACES = 2;

export function normalizeCustomTipInput(input: string): CustomTipInput {
	const sanitizedInput = input.replace(/[^\d.]/g, '');
	const [integerPart = '', ...decimalParts] = sanitizedInput.split('.');
	let inputValue = integerPart;

	if (decimalParts.length > 0) {
		const decimalPart = decimalParts.join('').slice(0, CUSTOM_TIP_MAX_DECIMAL_PLACES);
		inputValue += `.${decimalPart}`;
	}

	const numericValue = Number.parseFloat(inputValue);
	if (Number.isFinite(numericValue) && numericValue > CUSTOM_TIP_MAX_AMOUNT) {
		inputValue = String(CUSTOM_TIP_MAX_AMOUNT);
	}

	return {
		inputValue,
		amount: inputValue === '' || inputValue === '.' ? null : Number.parseFloat(inputValue),
	};
}

export function createCustomTip(amount: number): TipDetail | null {
	const amountText = amount.toString();
	const decimalPlaces = amountText.includes('e')
		? CUSTOM_TIP_MAX_DECIMAL_PLACES + 1
		: amountText.split('.')[1]?.length ?? 0;
	if (
		!Number.isFinite(amount) ||
		amount <= 0 ||
		amount > CUSTOM_TIP_MAX_AMOUNT ||
		decimalPlaces > CUSTOM_TIP_MAX_DECIMAL_PLACES
	) {
		return null;
	}

	return {
		percent: 0,
		value: amount,
		descripcion: 'Custom',
		selected: true,
		isCustom: true,
	};
}
